import * as actionTypes from '../constants/index'

export const setTheme = (data)=> {
    return {
        type: actionTypes.set_theme,
        data,
    }
};

